import React, { useState, useEffect } from 'react';
import { withStyles } from '@material-ui/core';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { isMobile } from 'react-device-detect';
import { resetDomiciliationLoading } from '../../../redux/actions/agentActions';
import Spinner from '../Spinner';

const styles = theme => ({
  domiciliationContainer: {
    width: '100%',
    background: '#F6F8FF',
    border: '1px solid #2D6DF6',
    borderRadius: '12px',
    padding: '20px',
    marginTop: '20px',
    display: 'flex',
    flexDirection: 'column',
    gap: '15px',
  },
  domiciliationTitle: {
    fontFamily: 'Sura Sans !important', 
    fontSize: '22px !important', 
    color: '#2D6DF6 !important',
    margin: '0 0 10px 0 !important',
  },
  domiciliationDescription: {
    fontSize: '16px',
    color: '#00003F !important',
    margin: 0,
    lineHeight: '1.5',
  },
  domiciliationButton: {
    backgroundColor: '#ffffff',
    color: '#0133A0',
    border: '1px solid #2D6DF6',
    borderRadius: '28px',
    padding: '10px 20px',
    cursor: 'pointer',
    fontFamily: 'Sura Sans',
    fontSize: '14px',
    alignSelf: 'flex-start',
    marginTop: '20px',
    transition: 'all 0.4s ease-in-out',
    '&:hover': {
      backgroundColor: '#2D6DF6',
      color: '#FFFFFF'
    }
  },
  domiciliationToast: {
    minWidth: isMobile ? '100%' : '800px',
    backgroundColor: '#F4C7C7',
    color: 'red',
    textAlign: 'center',
    borderRadius: '10px',
    padding: '16px',
    position: 'fixed',
    zIndex: 1000,
    left: '50%',
    transform: 'translateX(-50%)',
    bottom: '60px',
    fontSize: '17px',
    border: '1px solid red'
  }
});

function DomiciliationContainer({ 
  policy, 
  classes, 
  clientToken, 
  currency, 
  recurringPaymentRequestAgent,
  errorDomiciliationRequest,
  resetDomiciliationLoading
}) {
  const [loadingDomiciliation, setLoadingDomiciliation] = useState(false);
  const [showToast, setShowToast] = useState(false);

  // Domiciliation error
  useEffect(() => {
    if (errorDomiciliationRequest) {
      setShowToast(true);
      setTimeout(() => {
        setShowToast(false);
      }, 5000);
      resetDomiciliationLoading();
    }
  }, [errorDomiciliationRequest, resetDomiciliationLoading]);

  const handleDomiciliation = async (policy) => {
    try {
    setLoadingDomiciliation(true);
    
    const firstReceipt = policy.receipts[0];
    const amount = Number(firstReceipt.total);
    const currencyRate = policy.policy_details.currency === 'USD' ? currency : 1;

    const payload = {
      receipt: {
        uuid: firstReceipt.uuid,
        amount: amount,
        currency_rate: currencyRate
      },
      // Include token for backend to verify domiciliation permissions
      token: clientToken
    };

    await recurringPaymentRequestAgent(clientToken, payload);
    } finally {
      setLoadingDomiciliation(false);
    }
  };

  return (
    <React.Fragment>
      <div className={classes.domiciliationContainer}>
        <div
          style={{
            display: 'flex',
            alignItems: isMobile ? 'flex-start' : 'flex-end',
            flexDirection: 'column'
          }}
        >
          <div style={{ display: 'flex', width: '100%' }}>
            <div style={{ width: isMobile ? 'auto' : '8%' }}>
              <img 
                src="/img/Calendar.webp" 
                alt="Calendar" 
                style={{ width: '47px' }}
              />
            </div>
            <div style={{ width: isMobile ? 'auto' : '92%', paddingLeft: isMobile ? '15px' : '0' }}>
              <h3 className={classes.domiciliationTitle}>
                Selecciona aquí para domiciliar tu póliza
              </h3>
            </div>
          </div>
          <div style={{ width: isMobile ? '100%' : '92%' }}>
            <p className={classes.domiciliationDescription}>
              La domiciliación de pagos es un servicio que permite autorizar a un banco a realizar cargos automáticos a una cuenta bancaria para pagar productos o servicios. 
              <br/><br/>
              Esto elimina la necesidad de realizar los pagos de forma manual, lo que puede reducir errores y aumentar la eficiencia.
            </p>
            <button 
              className={classes.domiciliationButton}
              onClick={() => handleDomiciliation(policy)}
              disabled={loadingDomiciliation}
            >
              {loadingDomiciliation ? <Spinner /> : 'Domiciliar mi pago, cobros subsecuentes y renovaciones.'}
            </button>
          </div>
        </div>
      </div>
      {showToast && <div className={classes.domiciliationToast}>
          <span>No es posible domiciliar esta póliza, debido a que tiene uno o más recibos vencidos.</span>
      </div>}
    </React.Fragment>
  );
}

const mapStateToProps = state => ({
  errorDomiciliationRequest: state.agentReducer.errorDomiciliationRequest
});

const mapDispatchToProps = {
  resetDomiciliationLoading
};

export default compose(
  connect(mapStateToProps, mapDispatchToProps),
  withStyles(styles, { withTheme: true })
)(DomiciliationContainer); 


// WEBPACK FOOTER //
// ./src/containers/client/receipts/DomiciliationContainer.js